export const EXPIRING_DATA_STATE_TOKEN = 'EXPIRING_DATA';

export const EXPIRING_DATA_API_PATHS = {
    
};
